<template>
<div style="">
<div v-if="isLoading" class="loading">Loading&#8230;</div> 
    <vue-snotify/>

<div id="myModalContact" class="modal">
  <div class="modal-background"></div>
  <div class="modal-content" style="width:60%; height:85%;">
    <div  class="box has-background-grey">
        <Contact 
        :data_students="data_contact"
        :student_cnt="data_contact.length"
        :group_id="current_grpID"
        @emit_close_modal="close_contact_modal"
        >   </Contact>
    </div>
  </div>
</div>




<div class="columns is-vcentered is-gapless is-mobile has-background-grey-dark" style="">
    <div class="column is-1">
        <button @click="sortNav()" class="button is-fullwidth has-background-dark has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-angle-double-right"></i></span>     
        </button> 
    </div>
    <div class="column is-10 has-text-right has-background-grey-dark has-text-grey-lighter has-text-weight-bold " :class="return_text_size('is-size-5','is-size-7')">
        Groupes d'étudiants &nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <div v-if="!check_mobile()" class="column is-1 has-tooltip-bottom has-tooltip-success" data-tooltip="Nouveau Groupe">
        <button :disabled="check_access()" @click="group_add_toggle()" class="button is-fullwidth has-background-success has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-plus"></i></span>     
        </button> 
    </div>
</div>

<div v-if="new_group" name="fade">

        <CompGroupAddMain
        ref="compBatch"
        :data_profs="data_profs"
        :data_codes="data_codes"
        :data_courses="data_courses"
       
        @emit_group_insert_check_confirm="emit_group_insert_check_confirm"
        :key="randomKey()"
        > </CompGroupAddMain>

</div>
<!-- END NEW GROUPE  :data_add_group="data_add_group" -->
<!-- ***************************************************************** -->



<div id="mySidebar" class="sidebar" style="margin-top:3.7em;">
<div class="box is-radiusless has-background-grey-dark" style="margin-bottom:0em;">

<div class="columns is-multiline is-gapless is-mobile">


<div class="column is-10 is-size-6 has-text-grey-lighter">
    Rechercher des groupes
</div> 

<div class="column is-2">
    <button @click="test_encrypt()" class="button is-fullwidth has-background-dark has-text-white">
        <span class="icon is-small has-text-left"><i class="fas fa-angle-double-left"></i></span>     
    </button> 
</div>


<div v-if="+show_change_session" class="column is-12" style="">
<div class="columns is-multiline is-gapless">

    <div class="column margeBottomMore is-3 control">
    <div class="select is-fullwidth">
        <select v-model="grp_sess">
            <option value="H">H</option> <option value="E">E</option>  <option value="A">A</option>
        </select>
    </div></div> 

    <div class="column margeBottomMore is-4 control ">
    <div class="select is-fullwidth">
        <select v-model="grp_ann">
            <option>17</option><option>18</option><option>19</option> <option value="20">20</option><option>21</option><option>22</option>
        </select>
    </div></div>


    <div @click="session_annee_change()" class="column colBorderThin is-3 isLink has-text-centered" style="">
        <span class="icon is-small has-text-success mt-3"><i class="fas fa-thumbs-up"></i></span>
    </div>

    <div @click="session_annee_change_hide()" class="column colBorderThin is-2 isLink has-text-centered" style="">
        <span class="icon is-small has-text-danger mt-3"><i class="fas fa-minus-circle"></i></span>
    </div>



</div></div>

<div v-else class="column is-12" style="">
<div class="columns is-multiline is-gapless">
<div class="column is-1"></div>

<div class="column is-2 has-text-centered">
<a @click="session_annee_previous()" style="border: none;" class="button has-background-grey-dark has-text-warning"><span class="icon"><i class="fas fa-arrow-circle-left"></i></span></a> 
</div>

    <div @click="session_annee_change_show()" class="column is-6 box isLink has-background-info has-text-white is-size-4 has-text-centered has-text-weight-bold ">
        {{grp_sess}}-{{grp_ann}}
    </div>

<div class="column is-2 has-text-centered">
<a @click="session_annee_next()" style="border: none;" class="button is-borderless has-background-grey-dark has-text-warning"><span class="icon"><i class="fas fa-arrow-circle-right"></i></span></a> 
</div>


<div class="column is-1"></div>
</div></div>

<div class="column is-12">&nbsp;</div>


<!-- 

    <div class="column margeBottomMore control" :class="return_column_width('is-3','is-6')">
    <div class="select is-fullwidth">
        <select v-model="grp_sess" @change="reload()">
            <option>H</option> <option>E</option>  <option>A</option>
        </select>
    </div></div>

    <div class="column margeBottomMore control" :class="return_column_width('is-4','is-6')">
    <div class="select is-fullwidth">
        <select v-model="grp_ann" @change="reload()">
            <option>17</option><option>18</option><option>19</option> <option>20</option><option>21</option><option>22</option>
        </select>
    </div></div> -->




<!-- <div v-if="show_change_session==false" class="column" :class="return_column_width('is-12','is-12')"> 
<div class="select is-fullwidth">
        <select v-model="data_code_session" @change="get_distinct_groups_list()">
            <option value=""></option>
            <option v-for="(data,index) in data_codes_session_menu" :value="data.group_CODE"  :key="index" >{{ data.group_CODE }}</option>
        </select>
</div></div> -->
 
<div v-if="show_change_session==false" class="column is-paddingless has-text-centered is-size-6 has-text-weight-bold is-4 has-tooltip-bottom has-tooltip-info" data-tooltip="View By Group Code"><a class="button is-fullwidth has-background-grey-dark has-text-success" @click="group_menu_group()"><span class="icon is-medium"><i class="fas fa-users"></i></span></a></div>
<div v-if="show_change_session==false" class="column is-paddingless has-text-centered is-size-6 has-text-weight-bold is-4 has-tooltip-bottom has-tooltip-info" data-tooltip="View By Course Code"><a class="button is-fullwidth has-background-grey-dark has-text-success" @click="group_menu_course()"><span class="icon is-medium"><i class="fas fa-layer-group"></i></span></a></div>
<div v-if="show_change_session==false" class="column is-paddingless has-text-centered is-size-6 has-text-weight-bold is-4 has-tooltip-bottom has-tooltip-info" data-tooltip="View By Professor"><a class="button is-fullwidth has-background-grey-dark has-text-success" @click="group_menu_profs()"><span class="icon is-medium"><i class="fas fa-chalkboard-teacher"></i></span></a></div>
</div>
<!-- END ROW BUTTONS ....  --><!-- END ROWs COMBOS   -->


</div> <!-- end box -->




<!-- MENU  !!!! -->
<div v-if="show_change_session==false" class="box has-background-grey-light">
<div style="border: 1px solid #647882;cursor: pointer;" class="columns is-mobile" v-for ="(info, index) in data_menu" :key="index">    


<!-- SUMMARY  -->
<div class="column is-8 is-paddingless">
    <div v-if="group_view=='GROUP' && (active_view=='' || active_view=='SUMMARY' || active_view=='GROUP')" class="columns is-gapless">
        <div class="column is-2">
            <button @click="summary_show(info.data, index)" class="button is-fullwidth is-small">
                <span class="icon is-small">
                    <i class="fas fa-print"></i>
                </span>
            </button>
        </div>

        <div @click="menu_click(info.data, index, info.id, info.cnt )"  :class="return_style_menu(index)" class="column is-10 is-size-6"  style="padding-left:.4em;">&nbsp;&nbsp;{{ info.data}}</div>

    </div>
    <div v-else class="columns is-gapless">
        <div @click="menu_click(info.data, index, info.id, info.cnt )"  :class="return_style_menu(index)" class="column is-12 is-size-6"  style="padding-left:.4em;">&nbsp;&nbsp;{{ info.data}}</div>
    </div>
</div>
<!-- 
        <div  :class="return_style_menu(index)" class="column is-8 is-paddingless is-size-6"  style="padding-left:.4em;">&nbsp;&nbsp;{{ info.data}}</div> -->



    <div class="column is-2 has-text-centered has-background-light is-paddingless is-size-6 has-text-weight-bold has-text-info" style="">{{info.sessann}}</div>
    <div :class="return_style_clicked(index)" class="column is-2 has-text-centered  is-paddingless" style="border-left: 1px solid #647882;">{{info.cnt}}</div></div>
</div> <!-- end menu-->


</div>  <!-- end side-->



<div id="mainContent" >
<div class="columns is-gapless" style="margin-top:-1.6em;">
<div class="column is-12"> <!-- begin data-->




<div v-if="menu_view == 'COURSE'">

 <!-- MOBILE VIEW !!!! -->
<div v-if="check_mobile()">
<div class="columns has-background-grey-lighter is-vcentered  is-multiline is-gapless is-mobile" style="margin-bottom:0em;">

<div class="column is-6 has-text-weight-light has-text-left is-size-7">{{ groups[activeMenu].cour_TITRE_F }}</div>


<div @click="group_show_notes()" class="column isLink is-2 is-size-7 has-background-light"><span class="icon"><i class="fas fa-list-ol"></i></span>NOT</div>
<div @click="group_show_schedule()" class="column isLink is-2 is-size-7 has-background-light"><span class="icon"><i class="fas fa-calendar-alt"></i></span>HOR</div>

<!-- ** CONTACT BUTTON! v-if="check_contact_access()"  -->
<!-- <div @click="group_show_contact()" class="column isLink is-2 is-size-7 has-background-light"><span class="icon"><i class="fas fa-comment-alt"></i></span>CON</div>  -->


</div></div>
 <!-- END MOBILE VIEW !!!! -->


<div v-if="!check_mobile()">


<div class="columns has-background-grey-lighter is-vcentered  is-multiline is-gapless is-mobile" style="margin-bottom:0em;">

<div class="column is-1  has-text-weight-bold has-text-centered">
    {{ groups[activeMenu].group_CODE }}<span class="is-pulled-right has-text-grey-light">|</span> </div>
<div class="column  is-2  has-text-weight-bold has-text-centered">
    {{ groups[activeMenu].cour_CODE }}<span class="is-pulled-right has-text-grey-light">|</span></div>
<div class="column  is-4  has-text-weight-bold">&nbsp;&nbsp;{{ groups[activeMenu].prof1 }} {{ groups[activeMenu].prof2 }}
<span @click="create_excel()" class="icon isLink has-text-link is-pulled-right">
  <i class="fas fa-file-export"></i>&nbsp;&nbsp;
</span>


</div>


<div class="column  is-1 has-text-weight-bold colBorder">
    <a @click="group_show_notes()" class="button is-dark is-fullwidth"><span class="icon"><i class="fas fa-list-ol"></i></span><span>NOT</span>
    </a>
</div>
<div class="column  is-1 has-text-weight-bold colBorder">
    <a @click="group_show_details()" class="button is-dark is-fullwidth"><span class="icon"><i class="fas fa-info-circle"></i></span><span>DÉT</span>
    </a>
</div>
<div class="column  is-1 colBorder">
    <a @click="group_show_schedule()" class="button is-dark is-fullwidth"><span class="icon"><i class="fas fa-calendar-alt"></i></span><span>HOR</span>
    </a>
</div> 
<div class="column  is-1 colBorder has-tooltip-bottom has-tooltip-warning" style="" data-tooltip="les absences et les retards">
    <a @click="group_show_retards()" class="button is-dark is-fullwidth"><span class="icon"><i class="fas fa-clock"></i></span><span>ABS</span>
    </a>
</div>


<!-- <div class="column  is-1 colBorder">
    <a @click="group_show_files()" class="button has-background-grey-lighter has-text-info is-fullwidth"><span class="icon"><i class="fas fa-file-alt"></i></span><span>FICHERS</span>
    </a>
</div> -->

 <!-- 
     ** CONTACT BUTTON  v-if="check_contact_access()"-->
<div class="column  is-1 colBorder has-tooltip-bottom has-tooltip-warning" style="" data-tooltip="Contact Students">
    <a @click="contact_click()" class="button is-dark is-fullwidth"><span class="icon"><i class="fas fa-comment-alt"></i></span><span>CON</span>
    </a>
</div> 

<!-- <div class="column  is-1 colBorder">
    <a @click="group_show_transmission()" class="button has-background-grey-lighter has-text-info is-fullwidth"><span class="icon"><i class="fas fa-exchange-alt"></i></span><span>TRANS.</span>
    </a>
</div> -->

</div>

</div></div>
<!-- END HEADER ROW (COURSE VIEW) -->


<div class="column is-12 colNotes">
    {{dataReturn}}
</div>


<div v-if="active_view == 'FILES'" class="column is-12">
    <CompGroupFile
    :student_data="student_data"
    ></CompGroupFile>
</div>
<div v-if="active_view == 'CONTACT'" class="column is-12">
    <CompGroupContact
        :key="randomKey()"
        :group_id="current_grpID"
    ></CompGroupContact>
</div>
<div v-if="active_view == 'TRANSMISSION'" class="column is-12">
    <CompGroupTransmission
    :student_data="student_data"
    ></CompGroupTransmission>
</div>

 <div v-if="active_view == 'DETAILS' && current_grpID > 0" class="column is-12">
<transition name="fade">
    <CompGroupDetails
        :key="randomKey()"
        :group_id="current_grpID"
        :prof_data="data_profs"
        @emitCourseUpdate="emitCourseUpdate"
    ></CompGroupDetails>
</transition>
</div>

<div v-if="active_view == 'NOTES' && current_grpID > 0" >
<transition name="fade">
    <CompGroupNotes
        :key="randomKey()"
        :group_id="current_grpID"
    ></CompGroupNotes>
</transition>
</div> 

<div v-if="active_view == 'RETARDS' && current_grpID > 0" >
<transition name="fade">
    <CompRetards
        :key="randomKey()"
        :group_id="current_grpID"
    ></CompRetards>
</transition>
</div> 

<div v-if="active_view == 'SUMMARY'" >
<transition name="fade">
    <CompRapportSummary
        :key="randomKey()"
        :group_code="current_grpCODE"
    ></CompRapportSummary>
</transition>
</div> 


 <!-- style="margin-left:-.8em;margin-top:-.8em;" -->

<div v-if="active_view == 'SCHEDULE'" class="column is-12">
    <CompGroupSchedule 
        :key="randomKey()"
        type="group"
        :input_id="current_grpID"
        :dat_start="groups[activeMenu].group_datSTART" ></CompGroupSchedule>
</div>


<div v-if="menu_view == 'GROUP'" class="columns is-multiline is-centered is-vcentered"  style="padding:1em;">
<div class="column is-12" style="margin-top:-.4em;" v-for="(info, index) in groups" :key="index" >
<!-- <div class="box " :style="return_style_course_box(info.group_PUBLIC)" > -->
        <CompGroup 
        :index="index"
        @emitTheClick="emitTheClick"
        :info="info">
        </CompGroup>
<!-- </div> -->
</div>
</div> <!-- end data class="has-badge-rounded has-badge-info has-badge-large" data-badge="0">-->

</div>
</div>
</div>
</div>
</template>


<script>
import axios from 'axios';
import moment from 'moment';

  



import CompGroup  from '@/components/Comp_Group';

import CompRetards  from '@/components/Comp_Group_Retards';

import CompGroupNotes  from '@/components/Comp_Group_Notes';
import CompGroupDetails  from '@/components/Comp_Group_Details';
import CompGroupSchedule from "@/components/Comp_Group_Schedule";
import CompGroupFile from "@/components/Comp_Group_Files";
import CompGroupContact from "@/components/Comp_Group_Contact";
import CompGroupTransmission from "@/components/Comp_Group_Transmission";
import CompStudentBox  from '@/components/Comp_Student_Box';
//import Calendar from '@/components/Comp_Calendar'

import CompGroupAddMain  from '@/components/Comp_Group_Add_Batch_Main';
import Contact from '@/components/Comp_Contact'

import CompRapportSummary from '@/components/Comp_Rapport_Summary'

export default {
        components: { Contact , CompGroup, CompGroupAddMain, CompGroupNotes, CompGroupDetails, CompGroupSchedule,CompGroupFile ,CompGroupContact ,CompGroupTransmission, CompStudentBox, CompRetards, CompRapportSummary},

        data() {
            return {
                search:'',
                navOpen:false,

dataReturn:'',

grp_sess:'',
grp_ann:'',
data_code_session:[],
data_codes_session_menu:[],
data_codes_session_list:[],

                 groups:'',
                 students:'',
                 data_menu:'',
                 active_view:'NOTES', // WHAT WE'RE LOOKINGAT (NOTES,SCHED ...)
                 group_view:'GROUP',
                 menu_view:'GROUP',
                 activeMenu:0, // -----------------------> 
                 isLoading:false,
                 prof1:[],
                 prof2:[],

current_grpID:0,
current_grpCODE:0,

new_group:false,
new_group_next:false,

data_add_group:[],

new_grp_id:'',
new_grp_id_course:0,
new_grp_code:'',
new_grp_lang:'',
new_grp_dt_start:'',
new_grp_dt_end:'',
new_grp_sessann:'',
new_grp_prof1:'',
new_grp_prof2:'',


dt_sched_start:'',
dt_sched_end:'',
data_schedule_data:[],
groupID:-1, //FOR LOADING CALENDAR
comp_key_sched:0,

dtStart: '2019-09-24',

show_group:false,
show_notes:false,
show_schedule:false,

show_change_session:false,

group_data:[],
ponderation_data:[],
student_data:[], //USED IN LOOPS
student_copy:[], //USED IN DISPLAY

student_add:[], //USED TO DISPLAY STUDS TO ADD
search_students:'',

notes_data:[],

data_courses:[], //HOLD THE COURSES FOR SELECTION
data_codes:[], //HOLD THE DISTINCT GROUPS
data_ponds:[], //HOLD THE POND FOR COURSE

data_students:[], // HOLDS STUDENTS FOR SEARCHIN
data_students_add:[], // HOLDS STUDENTS FOR ADDING


isProf : false,

grp_dtStart:'',grp_dtEnd:'',
grp_prof1:'',grp_prof2:'',
data_profs:'',

show_new:false,

data_contact:[],

// GROUP QUERIES
// queryMain : `SELECT     COUNT(distinct MyMEQ_COURSESTUDENT.student_ID) AS cnt, MyMEQ_COUR.cour_ID, MyMEQ_COUR.cour_CODE, PROF1.staff_Prenom + ' ' + PROF1.staff_Nom AS prof1,PROF1.staff_ID AS prof1_ID, PROF2.staff_Prenom + ' ' + PROF2.staff_Nom AS prof2, PROF2.staff_ID AS prof2_ID, GRP.group_SESS + '' + GRP.group_ANN AS sessann, GRP.group_CODE, GRP.group_LANG, GRP.group_AVG, MyMEQ_COUR.cour_TITRE_F, MyMEQ_COUR.cour_TITRE_E, GRP.group_ID,group_datSTART,group_datEND,mymeq_sched_main.group_id AS schedID, group_PUBLIC FROM  MyMEQ_COUR INNER JOIN MyMEQ_GROUP AS GRP ON MyMEQ_COUR.cour_ID = GRP.cour_ID LEFT OUTER JOIN MyMEQ_COURSESTUDENT ON GRP.group_ID = MyMEQ_COURSESTUDENT.group_ID LEFT OUTER JOIN MyMEQ_STAFF AS PROF2 ON GRP.staff_ID_2 = PROF2.staff_ID LEFT OUTER JOIN MyMEQ_STAFF AS PROF1 ON GRP.staff_ID_1 = PROF1.staff_ID
// LEFT OUTER JOIN mymeq_sched_main ON  mymeq_sched_main.group_id = (SELECT  TOP 1 group_id FROM  mymeq_sched_main WHERE   group_id = GRP.group_ID) `,
// queryGroup : ` GROUP BY MyMEQ_COUR.cour_ID, MyMEQ_COUR.cour_CODE, PROF1.staff_Prenom + ' ' + PROF1.staff_Nom, PROF2.staff_Prenom + ' ' + PROF2.staff_Nom, GRP.group_SESS + '' + GRP.group_ANN, GRP.group_CODE, GRP.group_LANG, GRP.group_AVG, MyMEQ_COUR.cour_TITRE_F, MyMEQ_COUR.cour_TITRE_E , GRP.group_ID,group_datSTART,group_datEND,PROF1.staff_ID,PROF2.staff_ID,mymeq_sched_main.group_id, group_PUBLIC `,

queryMain : `SELECT     COUNT(distinct MyMEQ_COURSESTUDENT.student_ID) AS cnt, MyMEQ_COUR.cour_ID, MyMEQ_COUR.cour_CODE, PROF1.staff_Prenom + ' ' + PROF1.staff_Nom AS prof1,PROF1.staff_ID AS prof1_ID, PROF2.staff_Prenom + ' ' + PROF2.staff_Nom AS prof2, PROF2.staff_ID AS prof2_ID, GRP.group_SESS + '' + GRP.group_ANN AS sessann, GRP.group_CODE, GRP.group_LANG, GRP.group_AVG, MyMEQ_COUR.cour_TITRE_F, MyMEQ_COUR.cour_TITRE_E, GRP.group_ID,group_datSTART,group_datEND, group_PUBLIC, R.schedMain_ID
FROM  MyMEQ_COUR INNER JOIN MyMEQ_GROUP AS GRP ON MyMEQ_COUR.cour_ID = GRP.cour_ID LEFT OUTER JOIN MyMEQ_COURSESTUDENT ON GRP.group_ID = MyMEQ_COURSESTUDENT.group_ID LEFT OUTER JOIN MyMEQ_STAFF AS PROF2 ON GRP.staff_ID_2 = PROF2.staff_ID LEFT OUTER JOIN MyMEQ_STAFF AS PROF1 ON GRP.staff_ID_1 = PROF1.staff_ID
OUTER APPLY (SELECT TOP 1 schedMain_ID FROM myMEQ_SCHEDULE_MAIN WHERE group_ID = GRP.group_ID) R `,
queryGroup : ` GROUP BY MyMEQ_COUR.cour_ID, MyMEQ_COUR.cour_CODE, PROF1.staff_Prenom + ' ' + PROF1.staff_Nom, PROF2.staff_Prenom + ' ' + PROF2.staff_Nom, GRP.group_SESS + '' + GRP.group_ANN, GRP.group_CODE, GRP.group_LANG, GRP.group_AVG, MyMEQ_COUR.cour_TITRE_F, MyMEQ_COUR.cour_TITRE_E , GRP.group_ID,group_datSTART,group_datEND,PROF1.staff_ID,PROF2.staff_ID, group_PUBLIC, R.schedMain_ID `,



            }
        },




created() {


    //CHECK PROF 
    if (sessionStorage.getItem('user_level') == 'PROF') {
        this.isProf = true 
    }

    // SET INITIAL SESSION/ANNEE
    var sessann = moment().format('M')
    if (sessann < 5)  { this.grp_sess = 'H'}
    else if (sessann < 8) { this.grp_sess = 'E'}
    else  { this.grp_sess = 'A'}
    this.grp_ann =  moment().format('YY')


    this.group_load()

    
},

  watch: {
    // whenever question changes, this function will run

    grp_sess: function () {
        sessionStorage.setItem('sess', this.grp_sess)
      },    
    grp_ann: function () {
        sessionStorage.setItem('ann', this.grp_ann)},
    activeMenu: function () {
        sessionStorage.setItem('menu', this.activeMenu)},

  },




methods: {

test_encrypt:function() {
    axios.get(this.$url+'/file_decrypt')
    .then(res => { 
        alert(res.data)
        //this.dataReturn = res.data
    });
},


summary_show:function(grpCode, index) {
    this.activeMenu=index
    this.current_grpCODE = grpCode
    this.menu_view = 'SUMMARY'
    this.active_view = 'SUMMARY'
},


contact_click:function(key) {
    var query = `SELECT DISTINCT MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.prog_ID, MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_eMail, MyMEQ_STUDENT.student_TelHome
    , 1 AS goodToGo, 1 as isValid, 0 as isSent FROM MyMEQ_STUDENT INNER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID
    WHERE (group_ID = '` + this.current_grpID + `') ORDER BY student_lNAME`
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_contact = res.data
        document.querySelector('#myModalContact').classList.add('is-active');
    });

},
// END CONTACT CLICK ----
close_contact_modal:function(isSent) {
    document.querySelector('#myModalContact').classList.remove('is-active');
    if (isSent==true) {
        this.$snotify.success(' SENT !!', {
            timeout: 500,showProgressBar: true,closeOnClick: false,pauseOnHover: false
        }); 
    }
},

session_annee_change_show:function() {
    this.show_change_session = true
    this.active_view = ''
    this.menu_view = ''
},
session_annee_change_hide:function() {
    this.show_change_session = false
    this.menu_view = "GROUP"
    this.active_view =''
},

session_annee_change:function() {

    this.show_change_session=false
    // SET START/END DATE OF SESS/ANN
    if (this.grp_sess == 'H') {this.dt_sess_start = "20"+this.grp_ann+"-01-01" ; this.dt_sess_end = "20"+this.grp_ann+"-04-30"}
    else if (this.grp_sess == 'E') {this.dt_sess_start = "20"+this.grp_ann+"-05-01" ; this.dt_sess_end = "20"+this.grp_ann+"-08-31"}
    else {this.dt_sess_start = "20"+this.grp_ann+"-09-01" ; this.dt_sess_end = "20"+this.grp_ann+"-12-31"}
    this.reload()
},

session_annee_next:function() {
    if (this.grp_sess == 'H') {
        this.grp_sess = 'E' ; this.dt_sess_start = "20"+this.grp_ann+"-05-01" ; this.dt_sess_end = "20"+this.grp_ann+"-08-31"
    }
    else if (this.grp_sess == 'E') {
        this.grp_sess = 'A' ; this.dt_sess_start = "20"+this.grp_ann+"-09-01" ; this.dt_sess_end = "20"+this.grp_ann+"-12-31"
    }
    else {
        this.grp_ann = parseInt(this.grp_ann) + 1
        this.grp_sess = 'H' ; this.dt_sess_start = "20"+this.grp_ann+"-01-01" ; this.dt_sess_end = "20"+this.grp_ann+"-04-30"
    }
    this.reload()
},
session_annee_previous:function() {
    if (this.grp_sess == 'H') {
        this.grp_ann = parseInt(this.grp_ann) - 1
        this.grp_sess = 'A' ; this.dt_sess_start = "20"+this.grp_ann+"-09-01" ; this.dt_sess_end = "20"+this.grp_ann+"-12-31"
    }
    else if (this.grp_sess == 'E') {
        this.grp_sess = 'H' ; this.dt_sess_start = "20"+this.grp_ann+"-01-01" ; this.dt_sess_end = "20"+this.grp_ann+"-04-30"
    }
    else {
        this.grp_sess = 'E' ; this.dt_sess_start = "20"+this.grp_ann+"-05-01" ; this.dt_sess_end = "20"+this.grp_ann+"-08-31"
    }
    this.reload()
},


 

create_excel:function() {

        axios.post(this.$url+'/create_excel_file?groupID='+this.current_grpID, {responseType: "arraybuffer",  headers: {
        "Accept": "application/octet-stream",
        }})
        .then(res => { 
            
            var fileName = this.groups[this.activeMenu].group_CODE + ' ' + this.groups[this.activeMenu].cour_CODE
            window.open(this.$url+'/download_excel?filename='+fileName); });

},
 
// ------------------------------------
group_load:function() {
this.isLoading=true;
        // GET DISTINCT GROUPS PER SESS/ANN
        var sql =  "SELECT DISTINCT group_CODE FROM myMEQ_GROUP WHERE group_SESS = '" + this.grp_sess +  "' AND group_ANN = '" + this.grp_ann +  "' "
        sql +=  sessionStorage.getItem('sql_prof') + "  ORDER BY group_CODE"
        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
        .then(res => { this.data_codes_session_menu = res.data 


        var query = "SELECT staff_ID, staff_Nom  + ', ' + staff_Prenom AS prof FROM  MyMEQ_STAFF WHERE (staff_Type = 'PROF') " + sessionStorage.getItem('sql_prof')
        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
        .then(res => { this.data_profs = res.data
        //console.log(res.data)   

// GET COURSES
        var sql = "SELECT * FROM MyMEQ_COUR WHERE cour_CODE <> '' ORDER BY cour_CODE"
        // var sql = `SELECT DISTINCT MyMEQ_RELATION.prog_ID, MyMEQ_RELATION.cour_ID, MyMEQ_COUR.cour_CODE FROM MyMEQ_RELATION INNER JOIN MyMEQ_COUR ON MyMEQ_RELATION.cour_ID = MyMEQ_COUR.cour_ID GROUP BY MyMEQ_RELATION.prog_ID, MyMEQ_RELATION.cour_ID, MyMEQ_COUR.cour_CODE ORDER BY cour_CODE`
        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
        .then(res => { this.data_courses = res.data
        this.isLoading=false;

// GET CODES
        var sql =  "SELECT DISTINCT TOP (40)  group_CODE FROM myMEQ_GROUP ORDER BY group_CODE DESC"
        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
        .then(res => { this.data_codes = res.data



        this.group_menu_group()  
        setTimeout(() => {this.isLoading=false; this.openNav(); }, 500); 
        
        
        })  })   })   }) // END AXIOS'


}, // END GROUP LOAD ------------------

return_style_clicked:function(index) {
    if (index == this.activeMenu) {
        return ' has-background-primary'
    } 
},

check_mobile() {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return true} else {return false} 
},
return_column_width(colD, colM) {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return colM} else {return colD} 
},
return_text_size(sizeD, sizeM) {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return sizeM} else {return sizeD} 
},

// AFTER UPDATE OF COURSE - UPDATE MENU
emitCourseUpdate:function(iStuds) {
    //alert ('here:'+iNew)
    this.data_menu[this.activeMenu].cnt = iStuds
},

check_contact_access:function() {
// CHECK IF COLLEGE CAN EMAIL/SMS
    if (sessionStorage.getItem('college_canEMAIL') || sessionStorage.getItem('college_canSMS'))
    {return true}
    else {return false}
},

group_insert_finish:function()  {
    this.isLoading=true
// ADD STUDENT TO THE COURSE
    var i; var sql = '';
    for (i = 0; i < this.data_students_add.length; i++) 
    { sql += "INSERT INTO MyMEQ_COURSESTUDENT (student_ID, group_ID) VALUES (" + this.data_students_add[i] + "," + this.new_grp_id + ");"}
console.log(sql)    
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
    .then(res => { 
// GET COURSES FOR THIS CODE -- 
        this.data_code_session = this.new_grp_code
        this.get_distinct_groups_list(this.new_grp_id)
            this.isLoading=false
        })


},


doSynchronousLoop:function(data, processData, done) {
    if (data.length > 0) {
        var loop = function(data, i, processData, done) {
            processData(data[i], i, function() {
                if (++i < data.length) {  setTimeout(function(){ loop(data, i, processData, done);  }, 0);
                } else {    done();    }  });  };
        loop(data, 0, processData, done); } else { done(); }
}, // END SYNC LOOP





emit_group_insert_check_confirm:function(data) {

this.data_add_group = data

    // CHECK THE DATA
    for (var i = 0; i < this.data_add_group.length; i++) {
        if (!this.data_add_group[i].new_grp_code || !this.data_add_group[i].new_grp_dt_start || !this.data_add_group[i].new_grp_dt_end || !this.data_add_group[i].new_grp_id_course || !this.data_add_group[i].new_grp_lang) 
        {alert('Missing Data') ; return}
    } // END LOOP

    // IF HERE - GIVE A SEC, THEN GO
    setTimeout(() => {   
        this.$snotify.confirm('INSERT COURSE(s) ?', { timeout: 5000, showProgressBar: true, closeOnClick: false, pauseOnHover: false,
        position: "centerCenter",
            buttons: [
                {text: 'Yes', action: (toast) => this.group_insert_loop_start(toast)},
                {text: 'No', action: (toast) => this.$snotify.remove(toast.id)},
            ]  });
    }, 500);

},


group_insert_loop_start:function(toast) {
    this.$snotify.remove(toast.id) 
    this.doSynchronousLoop(this.data_add_group,this.group_insert_loop_do, this.group_insert_loop_end)
},

group_insert_loop_end:function() {
   
        this.new_group=false;
        this.new_group_next=false
        this.menu_view = "GROUP"
        this.group_load()


},


group_insert_loop_do:function(item, i, callback) {

    this.isLoading=true
// INSERT THE GROUP (COUR ID ONLY -- UPDATE REST)
    var sql = "INSERT INTO myMEQ_GROUP (cour_ID,group_blnComplete) VALUES (" + item.new_grp_id_course + ",0)"
    sql += ";SELECT MAX(group_ID) AS newID FROM myMEQ_GROUP"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
    .then(res => { this.new_grp_id = res.data[0].newID

var sql = ''
var self=this;

// !!!! !!!! !!!! !!!! PONDERATION!
if (item.ponderation.length>0) {
    item.ponderation.forEach(function(data){ 
        sql += " INSERT INTO MyMEQ_PROF_PONDERATION " 
        sql += " (group_ID ,ponderation_Desc ,ponderation_Percent ,ponderation_Max ,ponderation_Order ,ponderation_PUBLIC) VALUES ("
        sql += self.new_grp_id + ",'" + data.pond_DESC_F.replace(/'/g,"''") + "','" + data.pond_PERCENT + "','" + data.pond_MAX + "'," + data.pond_ORDER + "," + "0" + ");"
    });
}

// !!!! !!!! !!!! !!!! STUDENTS!
    for (i = 0; i < item.students.length; i++) 
    { sql += "INSERT INTO MyMEQ_COURSESTUDENT (student_ID, group_ID) VALUES (" + item.students[i] + "," + this.new_grp_id + ");"}


        sql += " UPDATE MyMEQ_GROUP SET "
        sql += " group_CODE = '" + item.new_grp_code
        sql += "', group_SESS = '" + item.new_grp_sessann.substr(0,1)
        sql += "', group_ANN = '" + item.new_grp_sessann.substr(2,2)
        sql += "', group_datSTART = '" +  moment(item.new_grp_dt_start).format('YYYY-MM-DD')
        sql += "',group_datEND = '" + moment(item.new_grp_dt_end).format('YYYY-MM-DD')
        sql += "', group_LANG = '" + item.new_grp_lang
        sql += "', staff_ID_1 = " + this.chk_prof(item.new_grp_prof1)
        sql += ", staff_ID_2 = " + this.chk_prof(item.new_grp_prof2)
        sql += " WHERE group_ID = " + this.new_grp_id 

console.log(sql)

let formData = new FormData();
formData.append('query', encodeURIComponent(sql));
axios({
    method: 'post',
    url: this.$url+sessionStorage.getItem('url_query_form'),
    data: {
        query:encodeURIComponent(sql)
    },
    
})
.then(res => {
    // this.isLoading = false;
    // callback()
    setTimeout(() => { console.log('done ----') ; this.isLoading = false; callback() }, 500);

})

    })


},
group_update:function() {

var sql = "UPDATE MyMEQ_GROUP SET "
sql += " group_CODE = '" + this.new_grp_code
sql += "', group_SESS = '" + this.new_grp_sessann.substr(0,1)
sql += "', group_ANN = '" + this.new_grp_sessann.substr(2,2)
sql += "', group_datSTART = '" +  moment(this.new_grp_dt_start).format('YYYY-MM-DD')
sql += "',group_datEND = '" + moment(this.new_grp_dt_end).format('YYYY-MM-DD')
sql += "', group_LANG = '" + this.new_grp_lang
sql += "', staff_ID_1 = " + this.chk_prof(this.new_grp_prof1)
sql += ", staff_ID_2 = " + this.chk_prof(this.new_grp_prof2)
sql += " WHERE group_ID = " + this.new_grp_id 
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
//console.log(sql)


},

chk_prof:function(val) {
    if (Number.isInteger(val))
    {return val} else {return null}
},




group_add_toggle:function() {

    if (this.new_group)  // IF OPEN -- THENCLOSE
        {               
        this.new_group=false;
        this.new_group_next=false
        this.menu_view = "GROUP"
        this.openNav()
        return}
    else { 
        this.data_add_group=[]        
        this.closeNav()
        this.active_view = ''
        this.menu_view =
        this.data_ponds = []     
        this.new_group = true 
        

        // this.group_add_click()
    }
}, // END GROUP NEW TOGGLE






student_remove:function(id) {
    alert('out ' + id )
},

// GET DISTINCT GROUPS PER SESS/ANN
/* get_distinct_groups_menu:function() {     
        var sql =  "SELECT DISTINCT group_CODE FROM myMEQ_GROUP WHERE group_SESS = '" + this.grp_sess +  "' AND group_ANN = '" + this.grp_ann +  "'  ORDER BY group_CODE"
        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
        .then(res => { this.data_codes_session_menu = res.data })
}, */


get_distinct_groups_list:function(gID) {
        // GET DISTINCT GROUPS PER SESS/ANN

 this.activeMenu = -1


    // CHECK IF NO CODE FILTER !!!!
    if (this.data_code_session == '')
    { this.group_menu_group() ; return}

    this.isLoading=true; 
    var queryWhere = ''
    if (this.data_code_session != '')
    { queryWhere =  " WHERE GRP.group_CODE LIKE '" + this.data_code_session + "%25' " }
    else { queryWhere =  ` WHERE (GRP.group_SESS = N'` + this.grp_sess + `') AND (GRP.group_ANN = N'` + this.grp_ann + `') `}

    queryWhere += sessionStorage.getItem('sql_prof').replace(/MyMEQ_GROUP/g,"GRP")


    var queryQUERY = this.queryMain + queryWhere + this.queryGroup
    queryQUERY += " ORDER BY group_datEND"


console.log('dickQ: ' +queryQUERY)
  
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(queryQUERY))
    .then(res => { 
      
        this.groups = res.data

console.log('GRPS:' + this.groups)

    //this.data_menu = []
    var arrMenu=[]
    var self = this;
    this.groups.forEach(function(d){
            arrMenu.push ({
            data : d.cour_CODE,
            id : d.group_ID,          
            cnt : d.cnt,
            sessann : d.sessann,
            title : d.cour_TITRE_F,
            dtS : d.group_datSTART,
            dtE : d.group_datEND,
        })
    }) 
    //this.activeMenu = 0
    //this.menu_view = 'COURSE'


if (gID) {



    this.active_view = 'GROUPS'
    this.menu_view = 'COURSE' 
// this.group_view
// GET ACTIVE MENU 
this.data_menu = arrMenu
    this.activeMenu = this.data_menu.findIndex(x => x.id == gID)

    this.current_grpID = gID

    setTimeout(() => { this.openNav(); }, 500);

} else {
  
 

    this.data_menu = arrMenu
   this.active_view = 'GROUP'
    this.menu_view = 'GROUP' 
}



this.isLoading=false; 



}) 

},

group_menu_group:function() {
    this.isLoading=true;
    this.group_details_clear()
    this.data_code_session = ''
    this.show_notes = false
    this.show_group = false;
    this.show_schedule = false
    this.menu_view = "GROUP"
    this.active_view =''

        this.groups = ''
        this.activeMenu = -1
        this.group_view='GROUP'
        this.data_menu = '';


var queryPlus = ''
//if (this.data_code_session != '')
//{ queryPlus =  " AND group_CODE LIKE '" + this.data_code_session + "%25' " }

var query = `select  distinct group_code as data, COUNT(MyMEQ_GROUP.group_ID) AS cnt from mymeq_group  INNER JOIN
MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID
WHERE     (MyMEQ_GROUP.group_SESS = N'` + this.grp_sess + `') AND (MyMEQ_GROUP.group_ANN = N'` + this.grp_ann + `')
` + queryPlus + sessionStorage.getItem('sql_prof') + `
GROUP BY MyMEQ_GROUP.group_code`;


        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
        .then(res => { this.data_menu = res.data
        
      //  this.get_distinct_groups_menu() 

// LOAD ALL(?) THE DATA ------------ > LOAD TOP MENU ITEM ....
this.group_data_courses("",0,0)


        this.isLoading=false;   }) 
},
group_menu_course:function() {
    this.isLoading=true;
    this.group_details_clear()
    this.data_code_session = ''
    this.show_notes = false
    this.show_group = false;
    this.show_schedule = false
    this.menu_view = "GROUP"
    this.active_view =''

        this.groups = ''
        this.activeMenu = -1
        this.group_view='COURSE'
        this.data_menu = '';

        var query = `select  distinct cour_CODE as data, COUNT(MyMEQ_GROUP.group_ID) AS cnt from mymeq_group  INNER JOIN
        MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID
        WHERE     (MyMEQ_GROUP.group_SESS = N'` + this.grp_sess + `') AND (MyMEQ_GROUP.group_ANN = N'` + this.grp_ann + `') ` + sessionStorage.getItem('sql_prof') + `
        GROUP BY MyMEQ_COUR.cour_CODE
        ORDER BY cour_CODE`;


        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
        .then(res => { this.data_menu = res.data
  
// LOAD ALL(?) THE DATA
this.group_view='COURSE' ; 
this.group_data_courses("",0,0)
this.group_view='COURSE'


        this.isLoading=false;   }) 
},
group_menu_profs:function() {
    this.group_details_clear()
    this.data_code_session = ''
    this.show_notes = false
    this.show_group = false;
    this.show_schedule = false
    this.menu_view = "GROUP"
    this.active_view =''

    this.isLoading=true;
        this.groups = ''
        this.activeMenu = -1
        this.group_view='PROF'
        this.data_menu = [];


this.prof1 = []
this.prof2 = []

    var query = `SELECT distinct staff_Prenom + ' ' + staff_Nom AS data, staff_ID as id, COUNT(group_ID) AS cnt FROM MyMEQ_GROUP AS GRP INNER JOIN  MyMEQ_COUR ON GRP.cour_ID = MyMEQ_COUR.cour_ID 
    LEFT OUTER JOIN MyMEQ_STAFF AS PROF1 ON GRP.staff_ID_1 = PROF1.staff_ID 
    WHERE (GRP.group_SESS = N'` + this.grp_sess + `') AND (GRP.group_ANN = N'` + this.grp_ann + `') ` + sessionStorage.getItem('sql_prof').replace(/MyMEQ_GROUP/g,"GRP") + `
    GROUP BY staff_Prenom + ' ' + staff_Nom , staff_ID
    ORDER BY staff_Prenom + ' ' + staff_Nom`;

        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
        .then(res => { this.prof1 = res.data

    var query = `SELECT distinct staff_Prenom + ' ' + staff_Nom AS data, staff_ID as id, COUNT(group_ID) AS cnt FROM MyMEQ_GROUP AS GRP INNER JOIN  MyMEQ_COUR ON GRP.cour_ID = MyMEQ_COUR.cour_ID 
    LEFT OUTER JOIN MyMEQ_STAFF AS PROF1 ON GRP.staff_ID_2 = PROF1.staff_ID 
    WHERE (GRP.group_SESS = N'` + this.grp_sess + `') AND (GRP.group_ANN = N'` + this.grp_ann + `') ` + sessionStorage.getItem('sql_prof').replace(/MyMEQ_GROUP/g,"GRP") + `
    AND  GRP.staff_ID_2 IS NOT NULL GROUP BY staff_Prenom + ' ' + staff_Nom , staff_ID
    ORDER BY staff_Prenom + ' ' + staff_Nom`;



            axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
            .then(res => { this.prof2 = res.data
               if (res.data) { 
                   
 
// PUT ARRAYS TOGETHER      //this.data_menu = this.prof1.concat(this.prof2)             
                   
    var tmpArr = this.prof1.concat(this.prof2)
    var self = this;
    tmpArr.forEach(function(dat){
        var iDex = self.data_menu.findIndex(o => o.id == dat.id)
        if (iDex == -1)
        {
            self.data_menu.push ({
                data : dat.data,
                id : dat.id,          
                cnt : dat.cnt,
            })
        } else 
        { self.data_menu[iDex].cnt = self.data_menu[iDex].cnt + dat.cnt }
    })
} // END AXIOS THEN ----

// LOAD ALL(?) THE DATA
this.group_view='PROF' ; 
this.group_data_courses("",0,0)
this.group_view='PROF'

                this.isLoading=false;
            })        
        }) 
},

reload:function() {
// SESSION/ANNEE CHANGE !

    this.menu_view = 'GROUP'
    this.active_view = 'GROUP'

this.activeMenu = -1

// GET DISTINCT GROUPS PER SESS/ANN
var sql =  "SELECT DISTINCT group_CODE FROM myMEQ_GROUP WHERE group_SESS = '" + this.grp_sess +  "' AND group_ANN = '" + this.grp_ann +  "'  ORDER BY group_CODE"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => { 
    
    this.data_codes_session_menu = res.data 

    switch (this.group_view) {
        case 'GROUP':
            this.group_menu_group()
            break;
        case 'COURSE':
            this.group_menu_course()
            break;
        case 'PROF':
            this.group_menu_profs()
            break;
    }

})

     //
},

group_data_students:function(id) {
        this.isLoading=true;

    var query = `SELECT *
    FROM MyMEQ_STUDENT INNER JOIN
    MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID INNER JOIN
    MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID INNER JOIN
    MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID
    WHERE MyMEQ_GROUP.group_ID = ` + id + `
    ORDER BY MyMEQ_STUDENT.student_lNAME`;


        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
        .then(res => { this.students = res.data
        this.isLoading=false;   }) 
},

menu_click:function(data,index,id,cnt) {


this.activeMenu=index

// CHECK IF ONLY ONE
    //if (cnt == 1) {
    //    alert('here')
    //    this.menu_view = 'GROUP'
    //    this.group_view = 'COURSE'
    //    this.group_details(id, index)
    //} else {

// CHECK IF IN SUMMARY VIEW
    if (this.menu_view == 'SUMMARY')
    {this.menu_view = 'GROUP' ; this.active_view = 'GROUP'}


        if (this.menu_view == 'COURSE' || this.data_code_session != '' ) {
            if (this.active_view == '' || this.active_view == "GROUP") { this.active_view = 'NOTES' }
            this.group_details(id, index)
        } else {
            this.show_schedule = false
            this.group_data_courses(data,index, id)
        }
    // CLOSE MENU IF MOBILE
    if (sessionStorage.getItem('isMobile') == 'true')
    {this.closeNav()}


},


group_data_courses:function(data,index, id) {
    this.group_details_clear()
    this.show_group = false;



// var queryMainX = `SELECT     COUNT(MyMEQ_COURSESTUDENT.cs_ID) AS cnt, MyMEQ_COUR.cour_ID, MyMEQ_COUR.cour_CODE, PROF1.staff_Prenom + ' ' + PROF1.staff_Nom AS prof1,PROF1.staff_ID AS prof1_ID,
// PROF2.staff_Prenom + ' ' + PROF2.staff_Nom AS prof2, PROF2.staff_ID AS prof2_ID, GRP.group_CODE, GRP.group_LANG, GRP.group_AVG, MyMEQ_COUR.cour_TITRE_F, MyMEQ_COUR.cour_TITRE_E, GRP.group_ID,group_datSTART,group_datEND,mymeq_sched_main.group_id AS schedID FROM  MyMEQ_COUR INNER JOIN MyMEQ_GROUP AS GRP ON MyMEQ_COUR.cour_ID = GRP.cour_ID LEFT OUTER JOIN MyMEQ_COURSESTUDENT ON GRP.group_ID = MyMEQ_COURSESTUDENT.group_ID LEFT OUTER JOIN MyMEQ_STAFF AS PROF2 ON GRP.staff_ID_2 = PROF2.staff_ID LEFT OUTER JOIN MyMEQ_STAFF AS PROF1 ON GRP.staff_ID_1 = PROF1.staff_ID
// LEFT OUTER JOIN mymeq_sched_main 
// ON  mymeq_sched_main.group_id =
//     (
//     SELECT  TOP 1 group_id 
//     FROM    mymeq_sched_main 
//     WHERE   group_id = GRP.group_ID
//     )`


 var queryWhere = ` WHERE (GRP.group_SESS = N'` + this.grp_sess + `') AND (GRP.group_ANN = N'` + this.grp_ann + `')  ` + sessionStorage.getItem('sql_prof').replace(/MyMEQ_GROUP/g,"GRP")
 var queryQUERY = this.queryMain + queryWhere



// var queryGroupX = ` GROUP BY MyMEQ_COUR.cour_ID, MyMEQ_COUR.cour_CODE, PROF1.staff_Prenom + ' ' + PROF1.staff_Nom, PROF2.staff_Prenom + ' ' + PROF2.staff_Nom, GRP.group_CODE, 
// GRP.group_LANG, GRP.group_AVG, MyMEQ_COUR.cour_TITRE_F, MyMEQ_COUR.cour_TITRE_E 
// , GRP.group_ID,group_datSTART,group_datEND,PROF1.staff_ID,PROF2.staff_ID,mymeq_sched_main.group_id`


var sWhere
var query


        this.isLoading=true;
        this.groups = ''
        this.activeMenu=index
        if (this.group_view=='ALL') {
             sWhere = " "


             query = queryQUERY + ' ' + sWhere + ' ' + this.queryGroup
            axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
            .then(res => { this.groups = res.data
            this.isLoading=false;   }) 

        } else if (this.group_view=='GROUP') {

// LOAD FIRST MENU ITEM BY DEFAULT
if (data == '') {
   if (this.data_menu.length > 0) {data = this.data_menu[0].data} else { return }
}


             sWhere = " AND GRP.group_CODE LIKE '" + data + "%25' "
             query = queryQUERY + ' ' + sWhere + ' ' + this.queryGroup

console.log('HERE ---------------------------------------------------------------')
console.log(query)

            axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
            .then(res => { this.groups = res.data
            this.isLoading=false;   })  

        } else if (this.group_view=='PROF') {

// LOAD FIRST MENU ITEM BY DEFAULT
if (id == 0) {
   if (this.data_menu.length > 0) {id = this.data_menu[0].id}
}


console.log('staffID: ' + id)         
if (!Number.isInteger(id))
{ sWhere = " AND (staff_ID_1 is null AND staff_ID_2 is null)"}
else {  sWhere = " AND (staff_ID_1 = " + id + " OR staff_ID_2 = " + id + ") "}



            // sWhere = " AND (staff_ID_1 = " + id + " OR staff_ID_2 = " + id + ") "
             query = queryQUERY + ' ' + sWhere + ' ' + this.queryGroup
console.log(query)
            axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
            .then(res => { this.groups = res.data
            this.isLoading=false;   }) 

        } else {


// LOAD FIRST MENU ITEM BY DEFAULT
if (data == '') {
   if (this.data_menu.length > 0) {data = this.data_menu[0].data} else { return }
}


             sWhere =  " AND cour_CODE = '" + data + "' "
             query = queryQUERY + ' ' + sWhere + ' ' + this.queryGroup
//console.log(query)
            axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
            .then(res => { this.groups = res.data
            this.isLoading=false;   })            
        }


},


//------------------------------

group_get_note:function(pond) {
//console.log(" - " + pond)
var notes;
notes = this.group_data.find(o => o.ponderation_ID === pond); //[...new Set(this.group_data.map(item => item.pond))];

//console.log(notes)


},

group_details_clear:function() {

    this.ponderation_data = []
    this.student_data = []

},


group_show_files:function() {
    this.active_view = "FILES"
},
group_show_contact:function() {
    this.active_view = "CONTACT"
},
group_show_transmission:function() {
    this.active_view = "TRANSMISSION"
},


group_show_schedule:function() {
    this.active_view = "SCHEDULE"
},
group_show_retards:function() {
    this.active_view = "RETARDS"
},
group_show_notes:function() {
    this.active_view = "NOTES"
},

group_show_details:function() {
    this.active_view = "DETAILS"

    this.grp_dtStart = this.groups[this.activeMenu].group_datSTART
    this.grp_dtEnd = this.groups[this.activeMenu].group_datEND
    this.grp_prof1 = this.groups[this.activeMenu].prof1_ID
    this.grp_prof2 = this.groups[this.activeMenu].prof2_ID
},


emitTheClick:function(gID , index, view) {

    this.active_view = view
    this.group_details(gID, index)

},


group_details:function(gID, index) {
    //alert('here')
    this.activeMenu=index
    
    if (this.active_view == '' || this.active_view == "GROUP") {this.active_view = 'NOTES' }
    
    var self = this;
    // MENU SWITCH ----> SHOW THE COURSES IN THE GROUP!
    if (this.menu_view == "GROUP") {
        this.data_menu = []
        this.groups.forEach(function(d){
            self.data_menu.push ({
                data : d.cour_CODE,
                id : d.group_ID,          
                cnt : d.cnt,
            sessann : d.sessann
            })
        })
    }
    this.menu_view = 'COURSE'
    this.current_grpID = gID
// });

},


group_details_X:function(gID, index) {
this.isLoading = true; 
this.group_details_clear()

this.activeMenu=index

if (this.active_view == '') {this.active_view = 'NOTES'}

//this.show_notes = true
 var self = this;
 

// MENU SWITCH
if (this.menu_view == "GROUP") {
    this.data_menu = []
    this.groups.forEach(function(d){
        self.data_menu.push ({
            data : d.cour_CODE,
            id : d.group_ID,          
            cnt : d.cnt
        })
    })
}

//format(this.groups[this.activeMenu].group_datEND, "yyyy-MM-dd")

 this.data_schedule_data=[]
// FOR CALENDAR
this.groupID = gID
//this.dt_sched_start =  parseISO(this.groups[this.activeMenu].group_datSTART) //myUtilities.get_date()
/* console.log(this.dt_sched_start)
this.dt_sched_start = startOfWeek(parseISO(this.groups[this.activeMenu].group_datSTART), {weekStartsOn: 1})
this.dt_sched_end = parseISO(this.groups[this.activeMenu].group_datEND) //addMonths(new Date(this.dt_sched_start), 4)
this.comp_key_sched = this.randomKey() // FORCE UPDATE?? */

//var query = `SELECT * FROM  MyMEQ_SCHED_MAIN WHERE group_id = '` + gID + `' ORDER BY date`

console.log('****')
console.log(query)

//var query = `SELECT MyMEQ_SCHED_MAIN.group_id,class_id, MyMEQ_SCHED_MAIN.date, MyMEQ_SCHED_MAIN.time1 AS db_time,  MyMEQ_SCHED_MAIN.salle AS db_salle, MyMEQ_SCHED_MAIN.prof AS db_prof, MyMEQ_COUR.cour_CODE, SUBSTRING(MyMEQ_COUR.cour_CODE, 5, 3) AS db_course, MyMEQ_SCHED_MAIN.custom, MyMEQ_SCHED_MAIN.colour
var query = `SELECT myMEQ_SCHEDULE_MAIN.*,myMEQ_SCHEDULE_ROOM.schedRoom_DESC,schedRoom_CAMPUS,  MyMEQ_STAFF.staff_Prenom + ' ' + MyMEQ_STAFF.staff_Nom AS prof , DATEADD(day, 1, schedMain_date) AS DateAdd
 FROM myMEQ_SCHEDULE_MAIN LEFT OUTER JOIN myMEQ_SCHEDULE_ROOM ON myMEQ_SCHEDULE_MAIN.schedRoom_ID = myMEQ_SCHEDULE_ROOM.schedRoom_ID LEFT OUTER JOIN  MyMEQ_STAFF ON myMEQ_SCHEDULE_MAIN.staff_ID = MyMEQ_STAFF.staff_ID  
 WHERE myMEQ_SCHEDULE_MAIN.group_id = '` + gID + `' ORDER BY schedMain_AmPmSoir`
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
        var i;
        for (i = 0; i < res.data.length; i++) {
          this.data_schedule_data.push( 
            { 
              title: res.data[i].schedMain_AmPmSoir + " : " + res.data[i].schedMain_CODE_COUR + " : " + res.data[i].schedMain_CODE_PROF,
              details: 'COUR : ' + res.data[i].schedMain_CODE_COUR + '<br>' + 'PROF : ' + res.data[i].prof + '<br>' + 'TIME : ' + res.data[i].schedMain_AmPmSoir + '<br>SALLE : ' + res.data[i].schedRoom_DESC + '<br><b>' + res.data[i].schedRoom_CAMPUS + '</b>',
              date: moment(res.data[i].DateAdd).format('YYYY-MM-DD'),
              open: false,
              class:'my-event',
              color: res.data[i].schedMain_COLOUR,
              hour:res.data[i].schedMain_AmPmSoir
            })
        } // END FOR

console.log(this.data_schedule_data)






this.menu_view = "COURSE"
var sql;
sql=`SELECT     MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_lNAME,MyMEQ_STUDENT.student_fNAME,student_GRPCODE,student_PhotoPath, MyMEQ_PROF_NOTES.note_ID , MyMEQ_PROF_NOTES.note_NOTE, MyMEQ_PROF_PONDERATION.*  ,cs_MARK,cs_REMARK
 FROM  MyMEQ_STUDENT INNER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID 
 LEFT OUTER JOIN
 MyMEQ_PROF_NOTES ON MyMEQ_COURSESTUDENT.cs_ID = MyMEQ_PROF_NOTES.cs_ID LEFT OUTER JOIN
 MyMEQ_PROF_PONDERATION ON MyMEQ_PROF_NOTES.ponderation_ID = MyMEQ_PROF_PONDERATION.ponderation_ID 
 WHERE     (MyMEQ_COURSESTUDENT.group_ID = ` + gID + `)
ORDER BY student_lNAME,ponderation_Order`



axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
.then(res => { 
    console.log(res.data)
    this.group_data = res.data


// GET SCHEDULE (DISTINCT DATES)

/* self.group_data.filter(function(item){
  var i = self.data_schedule_data.findIndex(x => (x.date == item.date));
  if(i <= -1){
        self.data_schedule_data.push(item);
  }
}) */


// GET DISTINCT PONDERATIONS
self.group_data.filter(function(item){
  var i = self.ponderation_data.findIndex(x => (x.ponderation_ID == item.ponderation_ID));
  if(i <= -1){
        self.ponderation_data.push(item);
  }
})


//self.student_data = Array.from(new Set(self.group_data));

// GET DISTINCT STUDENTS
self.student_copy = [];
self.group_data.forEach(function(item){    
  var i = self.student_data.findIndex(x => (x.student_ID == item.student_ID));
  if(i <= -1){
      self.student_copy.push(item);
      //self.student_data.push(item);
     // console.log('STUD : ' + item.student_ID)

        var s_object = {};
        s_object.student_ID = item.student_ID,
        s_object.student_lNAME = item.student_lNAME,
        s_object.student_fNAME = item.student_fNAME,
        s_object.student_GRPCODE = item.student_GRPCODE
        s_object.student_PhotoPath = item.student_PhotoPath
        s_object.cs_MARK = item.cs_MARK
        s_object.cs_REMARK = item.cs_REMARK
        s_object.isEnrolled = true

        self.student_data.push(s_object);

/*     self.student_data.push({ 
        student_ID : item.student_ID,
        student_lNAME : item.student_lNAME,
        student_fNAME : item.student_fNAME
        }); */

  }
})

    //this.ponderation_data = [...new Set(this.group_data.map(item => item.ponderation_ID))];
    //this.student_data = [...new Set(this.group_data.map(item => item.student_lNAME))];

this.notes_data = [];

var tempArr;
var note = ''



self.student_data.forEach(function(stud, index){ 
self.ponderation_data.forEach(function(pond, index){
    
 


tempArr = [];

//console.log('xxx' + pond.ponderation_ID + 'xxx')
self.group_data.forEach(function(dataGrp){
   
        if ((pond.ponderation_ID == dataGrp.ponderation_ID) && (stud.student_ID = dataGrp.student_ID)) {         
                note += dataGrp.note_NOTE + '|' + dataGrp.note_ID + ','
                //console.log(note + ' : ' + stud)
        }
    }) // END GRP LOOP

//alert(note + ' : ' + stud)

var str_array = note.split(',');
for(var i = 0; i < str_array.length; i++) {

    var n_array = str_array[i].split('|');
    tempArr.push({ 
        note : n_array[0],
        id : n_array[1]
        });
}
//console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
//console.log( note)
note = ''

    self.notes_data.push({
        notes: tempArr});
    }) // END STUD LOOP


    }) // END POND LOOP


    this.isLoading = false;
 }) // END SCHEDULE DATA    
}) // END AXIOS
},



// GENERATE A NEW ID! 
    randomKey:function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });},
return_style_menu:function(index) {

if (this.menu_view == 'GROUP') {
    return ' has-background-light'
} else {
    if (index == this.activeMenu) {
        return ' has-background-primary'
    } else {
        return ' has-background-light'
    }
}

}, // END STYLE MENU OLIVEDRAB

return_style_course_box:function(bPublic) {

    if (+bPublic)
    { return "background-color:#8FBC8B"}
    else {return "background-color:hsl(0, 0%, 29%)"}

},


check_access:function() {
// CHECK IF CAN ADD NEW SCHED
    if (sessionStorage.getItem('user_level') === 'ADMIN') 
    {return false} else {return true}
},


sortNav() {
    if (this.navOpen) {this.closeNav()} else {this.openNav()}
},
openNav() {
  document.getElementById("mySidebar").style.width = "300px";
  document.getElementById("mainContent").style.marginLeft = "300px";
  this.navOpen = true;
  this.new_show= false;
  this.new_group=false
  this.new_group_next=false
},
/* Set the width of the sidebar to 0 and the left margin of the page content to 0 */
closeNav() {  
  document.getElementById("mySidebar").style.width = "0";
  document.getElementById("mainContent").style.marginLeft = "0";
  this.navOpen = false;
},


students_search:function() {

    this.data_students = [] // CLEAR ADD
        if (this.search_students == '') {return;}

        this.isLoading=true;

    var query =  `SELECT  TOP (100) MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_lNAME, 
    MyMEQ_STUDENT.student_CodePerm, MyMEQ_STUDENT.student_blnActive, MyMEQ_STUDENT.student_blnComplete, MyMEQ_STUDENT.student_PhotoPath, 
    MyMEQ_PROGRAM.prog_ID,MyMEQ_PROGRAM.prog_CODE, COUNT(MyMEQ_COURSESTUDENT.group_ID) AS cnt, MAX(MyMEQ_GROUP.group_datEND) AS maxDt
    ,student_rueNUM + ' ' + student_Address + '   ' + student_apt + ',  ' + student_City AS ADDRESS,prog_TITRE_F,prog_TITRE_E, student_TelHome, student_TelOther, student_eMail ,  student_SecretCode, student_CreateDate
    FROM  MyMEQ_STUDENT LEFT OUTER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID LEFT OUTER JOIN MyMEQ_PROGRAM ON MyMEQ_STUDENT.prog_ID = MyMEQ_PROGRAM.prog_ID LEFT OUTER JOIN  MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID        
    WHERE  student_GRPCODE LIKE '` + this.search_students  + `%25' OR 
    student_lNAME LIKE '` + this.search_students  + `%25' OR 
    student_CodePerm LIKE '` + this.search_students  + `%25'  
    GROUP BY MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_lNAME, 
    MyMEQ_STUDENT.student_CodePerm, MyMEQ_STUDENT.student_blnActive, MyMEQ_STUDENT.student_blnComplete, MyMEQ_STUDENT.student_PhotoPath, 
    MyMEQ_PROGRAM.prog_ID,MyMEQ_PROGRAM.prog_CODE,prog_TITRE_F,prog_TITRE_E,student_rueNUM,student_Address ,student_apt,  student_City, student_TelHome, student_TelOther, student_eMail,  student_SecretCode , student_CreateDate  
    ORDER BY student_lNAME,student_fNAME`;

        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
        .then(res => { this.data_students = res.data
        this.isLoading=false;   })  
},
search_clear:function(){
    this.isLoading=true;
    this.student_add = ''
    this.data_students = [] // CLEAR ADD SEARCH
    this.search_students = ''
    this.isLoading=false;
},

emit_click_add:function(studentID) {
    //alert('add '+ studentID)
    this.data_students_add.push(studentID)
    //this.is_changed = true;
}, 
emit_click_add_undo:function(studentID) {
    //alert('add-undo '+ studentID)
   // this.is_changed = true;
     const index = this.data_students_add.indexOf(studentID);
     if (index > -1) {
        this.data_students_add.splice(index, 1);
     }
},









}, // END METHODS

} // END EXPORT
</script>




<style scoped>

select {
  text-align: center;
  text-align-last: center;
  font-weight: 900;
  /* webkit*/
}
option {
  text-align: left;
  /* reset to left*/
}

</style>